// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointsComparisonResponseItemFromJSON, DatapointsComparisonResponseItemToJSON, } from './';
export function DatapointsComparisonResponseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'responses': !exists(json, 'responses') ? undefined : json['responses'].map(DatapointsComparisonResponseItemFromJSON),
    };
}
export function DatapointsComparisonResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'responses': value.responses === undefined ? undefined : value.responses.map(DatapointsComparisonResponseItemToJSON),
    };
}
